import React from "react";


import { MailOutline } from "@mui/icons-material";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";
import { useScrolled } from "Hooks/useScrolled";
import { useTranslation } from "react-i18next";

import RemoveEscalationModal from "./RemoveEscalationModal";
import RequestEscalationModal from "./RequestEscalationModal";
import { ContactUsButton } from "./styled";

export const OrderPagePopups = () => {
  const {
    escalationIsRequested,
    openRemoveEscalationRequest,
    openRequestEscalationModal,
    setOpenEscalationModal,
    setOpenRemoveEscalationRequest,
  } = useCustomerPortalJobContext();

  const { isScrolled } = useScrolled();
  const { t: translate } = useTranslation();

  const returnButtonText = () => {
    if (isScrolled) return null;

    return escalationIsRequested ? translate("escalationContactRaised") : translate("contactUs");
  };

  return (
    <>
      {openRemoveEscalationRequest && (
        <RemoveEscalationModal
          open={openRemoveEscalationRequest}
          onClose={() => setOpenRemoveEscalationRequest(false)}
        />
      )}
      {openRequestEscalationModal && (
        <RequestEscalationModal
          open={openRequestEscalationModal}
          onClose={() => setOpenEscalationModal(false)}
        />
      )}

      <ContactUsButton
        onClick={() => {
          setOpenEscalationModal(true);
        }}
      >
        <MailOutline />
        {returnButtonText()}
      </ContactUsButton>
    </>
  );
};
